var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "site container-fluid px-0" },
    [
      _vm.isLoading ? _c("loading-overlay") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "error-container" }, [
        !_vm.isLoading
          ? _c("div", [
              _c("div", { staticClass: "error-content text-center" }, [
                _c(
                  "div",
                  { staticClass: "row m-0" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-lg-4 image-col" },
                      [
                        _c(
                          "transition",
                          {
                            attrs: {
                              name: "bounce",
                              "enter-active-class": "bounceInLeft"
                            }
                          },
                          [
                            _vm.showWithDelay
                              ? _c("img", {
                                  attrs: { src: _vm.logoUrl, alt: "error" }
                                })
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "transition",
                      {
                        attrs: {
                          name: "bounce",
                          "enter-active-class": "bounceInRight"
                        }
                      },
                      [
                        _vm.showWithDelay
                          ? _c(
                              "div",
                              { staticClass: "col-lg-8 text-col text-md-left" },
                              [
                                _c("h1", [_vm._v("Oops...")]),
                                _vm._v(" "),
                                _c("h1", { staticClass: "pt-0" }, [
                                  _vm._v(_vm._s(_vm.errorName) + ".")
                                ]),
                                _vm._v(" "),
                                _c("p", [_vm._v(_vm._s(_vm.errorDescription))]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "error-btn px-3",
                                    attrs: { role: "link" },
                                    on: {
                                      click: function($event) {
                                        return _vm.navigateHome()
                                      }
                                    }
                                  },
                                  [_vm._v("GO TO AUTODESK ONE HOME")]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f7f9c7ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7f9c7ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErrorPageWithHeader.vue
// module id = null
// module chunks = 